module.exports = __webpack_public_path__ + "img/ring_y_0_1_1.b60481a0.png";